import { ChangelogAspect } from './changelog.aspect';

export type { ChangeLogPageProps } from './ui/change-log-page';

export type { ChangeLogUI } from './changelog.ui.runtime';
export { ChangelogAspect };
export default ChangelogAspect;
